import { render, staticRenderFns } from "./DistributionCard.vue?vue&type=template&id=f2aeb99a&scoped=true"
import script from "./DistributionCard.vue?vue&type=script&lang=js"
export * from "./DistributionCard.vue?vue&type=script&lang=js"
import style0 from "./DistributionCard.vue?vue&type=style&index=0&id=f2aeb99a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aeb99a",
  null
  
)

export default component.exports